// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"738":"d8cd7e0aed2549155bf9","888":"d8aad33022d93d571b1c"}[chunkId] + ".css";
};